import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/influencers'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  id: 0,
  contactData: {
    identityId: 0
  },
  influencer: {}
})

export default handleActions({
  [Actions.openAddInfluencerToContactsDialog]: (state, { payload }) => (
    state.set('id', payload)
  ),
  [Actions.updateContactData]: (state, { payload: { identityId } }) => state.setIn(['contactData', 'identityId'], identityId),
  [Actions.fetchInfluencerSuccess]: (state, { payload }) => {
    const influencer = payload.allContacts.total === 1 ? payload.allContacts.contacts[0] : null

    if (influencer) {
      return state.set('influencer', fromJS(influencer))
    }

    return state
  },
  [Actions.closeAddInfluencerToContactsDialog]: () => initialState,
  [AppActions.resetState]: () => initialState
}, initialState)
